export default {
  addOns: 'Ek Hizmetler',
  all: 'Tümü',
  browse: 'Gözat',
  buyTickets: 'Bilet sat\u0131n al',
  countSelected: '{{count}} seçildi',
  joinWaitlist: 'Bekleme Listesine Kat\u0131l',
  joining: 'Kat\u0131l\u0131n\u0131yor',
  salesEnded: 'Sat\u0131\u015flar sona erdi',
  schedule: 'Program',
  soldOut: 'T\u00fckenmi\u015f',
  tickets: 'Biletler',
  noDatesAvailable: 'Uygun tarih yok',
  seeMoreDates: 'Daha fazla tarih g\u00f6r',
  about: 'Hakk\u0131nda',
  agenda: 'G\u00fcndem',
  menu: 'Men\u00fc',
  included: 'Dahil',
  viewMore: 'Daha fazla g\u00f6r',
  viewLess: 'Daha az g\u00f6r',
  location: 'Konum',
  time: 'Saat',
  at: 'saat',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Bu tarihte bu grup b\u00fcy\u00fckl\u00fc\u011f\u00fc i\u00e7in uygun saat yok',
  availableTimes: 'Uygun saatler',
  waitlist: 'Bekleme Listesi',
  continue: 'Devam',
  ticketsAreNoLongerAvailable: 'Biletler art\u0131k mevcut de\u011fil.',
  checkOutOutOtherExperiences: 'Di\u011fer deneyimlerimize g\u00f6z at\u0131n!',
  viewExperiences: 'Deneyimleri g\u00f6r\u00fcnt\u00fcle',
  from: 'ba\u015flang\u0131\u00e7',
  cancellationPolicy: '\u0130ptal politikas\u0131',
  rsvp: 'RSVP',
  nights: 'gece',
  request: 'Talep',
  arrival: 'Var\u0131\u015f',
  departure: 'Ayr\u0131l\u0131\u015f',
};
